import { defineStore } from 'pinia';
import { ref } from 'vue';

import {
  usePaxStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';
import { CoreEventSource } from '@apps/main/new-desktop/core/models';

import {
  trackPaxStartChanging,
  trackPaxEndChanging,
} from '@libs/google-analytics-events';
import type { Pax } from '@libs/trip-planner-interfaces';

import { ActivitySelectionModalType } from '../models';

export const useActivitySelectionModalsStore = defineStore(
  'ActivitySelectionModalsStore',
  () => {
    const paxStore = usePaxStore();
    const statsigEventsStore = useStatsigEventsStore();

    // State
    const activitySelectionModalType = ref<ActivitySelectionModalType>(
      ActivitySelectionModalType.None
    );

    // Actions
    function closeActivitySelectionModal(): void {
      activitySelectionModalType.value = ActivitySelectionModalType.None;
    }

    function openPaxSelectorModal(): void {
      trackPaxStartChanging();
      statsigEventsStore.logCorePaxModalOpened({
        source: CoreEventSource.ActivitySelection,
      });
      activitySelectionModalType.value = ActivitySelectionModalType.PaxSelector;
    }

    function confirmPaxSelectorModal(newPax: Pax): void {
      trackPaxEndChanging();
      paxStore.updatePax(newPax, CoreEventSource.ActivitySelection);
      activitySelectionModalType.value = ActivitySelectionModalType.None;
    }

    function openMobileFiltersModal(): void {
      activitySelectionModalType.value =
        ActivitySelectionModalType.MobileFiltersModal;
    }

    function openWhyWeSuggestModal(): void {
      activitySelectionModalType.value =
        ActivitySelectionModalType.WhyWeSuggest;
    }

    return {
      // State
      activitySelectionModalType,

      // Actions
      closeActivitySelectionModal,
      openPaxSelectorModal,
      confirmPaxSelectorModal,
      openMobileFiltersModal,
      openWhyWeSuggestModal,
    };
  }
);
